
import Vue from 'vue'
import range from '@/common/utils/range'
import withinBounds from '@/common/utils/withinBounds'

export default Vue.extend({
  props: {
    color: String,
  },

  data: () => ({
    barWidth: 3,
    spaceWidth: 3,
    maxHeight: 22,
    minHeight: 10,
    halfLength: 9,
  }),

  computed: {
    width: function() {
      return (this.barWidth + this.spaceWidth) * this.halfLength * 2
    },
    height() {
      return this.maxHeight
    },
    rects() {
      const heightBounds = withinBounds(this.maxHeight, this.minHeight)
      const yChange = (this.maxHeight - this.minHeight) / 2
      const yBounds = withinBounds(yChange)

      return range(this.halfLength * 2).map(i => {
        const height = heightBounds(
          i < this.halfLength
            ? this.minHeight + i * 2
            : this.minHeight + (this.halfLength * 2 - i - 1) * 2
        )

        const y = yBounds(
          i < this.halfLength
            ? yChange - i
            : yChange - 2 * this.halfLength + i + 1
        )

        return {
          height,
          y,
          x: i * (this.barWidth + this.spaceWidth),
          key: i,
        }
      })
    },
  },
})
